import React, { useEffect, useState } from "react";
import * as Yup from "yup";
import { Formik } from "formik";
import { useI18next } from "../../../../plugins/gatsby-plugin-ap-i18next/src/useI18next";

import { authForm, input, button, imageUploader } from "./auth-forms.module.scss";

import Input from "../../../../src/components/atoms/form/input";
import FormikForm from "../../../../src/components/hoc/formik-form";
import Button from "../../../../src/components/atoms/button";
import useUser from "../hooks/use-user";
import ImageUploader from "../../../components/molecules/image-uploader";
import { uploadFileToApi } from "../../../services/fileupload-services";
import { getUserPhoto } from "../../../services/user-services";
import endpoints from "../../../config/endpoints";

const updateDataSchema = Yup.object({
    name: Yup.string(),
    email: Yup.string(),
});

const AccountDataForm = () => {
    const { t } = useI18next();
    const { updateProfile, data, profile } = useUser();

    const [uploadFile, setUploadFile] = useState<File | null>(null);
    const [imageUrl, setImageUrl] = useState("");

    const onUploadPhoto = (file: File) => {
        console.log("onUploadPhoto called: ", file);
        setUploadFile(file);
    }

    useEffect(() => {
        getUserPhoto(2).then(async (response) => {
            // console.log("Pobrano zdjęcie profilowe: ", response);
            setImageUrl(response.base64);
        });
    }, [])

    return (
        <Formik
            initialValues={{ name: profile.firstName, email: data?.email || "" }}
            validationSchema={updateDataSchema}
            onSubmit={async (values, formikHelpers) => {
                await updateProfile(values); // wywołanie hooka
                if (uploadFile) {
                    var uploadResponse = await uploadFileToApi(uploadFile);
                }
                console.log("Zaktualizowano profil i przesłano plik");
            }}
        >
            {(formik) => (
                <FormikForm formik={formik} successMessage={""} className={authForm}>
                    <Input
                        name="name"
                        type="name"
                        placeholder={t("form.label.data")}
                        className={input}
                    />

                    <Input
                        name="email"
                        type="email"
                        disabled
                        placeholder={t("form.label.email")}
                        className={input}
                    />

                    {/* wypada wyswietlić zdjęcie profilowe */}
                    <div className={imageUploader}>
                        <ImageUploader onUploadPhoto={onUploadPhoto} imageUrl={imageUrl}></ImageUploader>
                    </div>

                    <Button color="primary" type="filled" htmlType="submit" className={button}>
                        {t("button.new-data")}
                    </Button>
                </FormikForm>
            )}
        </Formik>
    );
};

export default AccountDataForm;
